var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGradientRefresh = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.096,
    y1: 0.331,
    x2: 0.9,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#265df5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5dc9f0"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "refresh",
    d: "M9.667.034,8.358,1.341A5.053,5.053,0,0,0,6.82.38,4.844,4.844,0,0,0,5,.034,4.847,4.847,0,0,0,2.182.907,4.921,4.921,0,0,0,.361,3.175l1.162.468A3.706,3.706,0,0,1,2.885,1.936,3.626,3.626,0,0,1,5,1.283a3.617,3.617,0,0,1,2.48.946L6.249,3.468a.287.287,0,0,0,.313.312H9.579a.384.384,0,0,0,.269-.132.428.428,0,0,0,.142-.269L10,.258q.01-.234-.332-.224ZM5,8.775a3.639,3.639,0,0,1-2.48-.936L3.749,6.6a.281.281,0,0,0-.083-.229.312.312,0,0,0-.229-.093H.419a.429.429,0,0,0-.269.141.428.428,0,0,0-.142.269L0,9.809q-.01.234.332.224L1.64,8.726a4.976,4.976,0,0,0,1.538.956A4.91,4.91,0,0,0,5,10.023a4.865,4.865,0,0,0,2.817-.868A4.89,4.89,0,0,0,9.637,6.882L8.476,6.424a3.678,3.678,0,0,1-1.362,1.7A3.643,3.643,0,0,1,5,8.775Z",
    transform: "translate(0.001 -0.034)",
    fill: "url(#linear-gradient)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGradientRefresh);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/gradient_refresh.663ffa89a840e0846900c21a75c27843.svg";